exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mt-30[data-v-299c0b96]{margin-top:30px}", ""]);

// exports
